<div class="sort-bar">
  <div class="sort-bar__inner">
    <p class="sort-bar__count" i18n="@@category.sort.count">顯示 {{ count }} 款產品</p>

    <div class="sort-bar__dropdown" [class.is-open]="isOpen">
      <button
        type="button"
        class="sort-bar__trigger"
        [attr.aria-expanded]="isOpen"
        aria-haspopup="listbox"
        (click)="toggle()">
        <span class="sort-bar__trigger-prefix" i18n="@@category.sort.label">排序:</span>
        <span class="sort-bar__trigger-value">{{ currentLabel }}</span>
        <svg class="sort-bar__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>

      <ul class="sort-bar__menu" role="listbox" *ngIf="isOpen">
        <li
          *ngFor="let opt of options"
          class="sort-bar__option"
          [class.is-active]="opt.key === currentSort"
          role="option"
          [attr.aria-selected]="opt.key === currentSort"
          (click)="select(opt)">
          <span class="sort-bar__option-label">{{ opt.label }}</span>
          <svg *ngIf="opt.key === currentSort" class="sort-bar__option-check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </li>
      </ul>
    </div>
  </div>
</div>
